export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8488.5eda9c87.jpg";